module.exports = __webpack_public_path__ + "img/bordura_small.9e359463.jpg";